// @flow

import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/styles';
import {getImageUrl} from '../../../../../../utils/image_provider';
import {IconButton, Typography} from '@material-ui/core';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import {colors} from '../../../../../../assets/styles/colors';

import type {Tax} from '../../../../../../entities';
type Props = {
  item: Object,
  handleDeleteItem: (id: string) => void,
};

const useStyles = makeStyles(theme => ({
  item: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  rowItem: {
    width: '100%',
    display: 'flex',
  },
  imageItem: {
    borderRadius: '8px',
  },
  wrapItemName: {
    width: '100%',
    margin: theme.spacing(0, 1, 0, 2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  nameItem: {
    width: '100%',
    textAlign: 'left',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    color: colors.grey800,
  },
  deleteButton: {
    color: '#E54D7B',
  },
  wrapTaxes: {
    width: '100%',
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap',
  },
  taxLabel: {
    padding: theme.spacing(0.5, 1),
    background: colors.grey300,
    borderRadius: 6,
    '& p': {
      fontWeight: 500,
      color: colors.grey800,
      fontSize: 12,
    },
  },
}));
export default function RowItem(props: Props) {
  const {item, handleDeleteItem} = props;
  const classes = useStyles();

  const productTaxes =
    item && item.taxes ? item.taxes.filter(t => t.enabled) : undefined;

  const buildTaxLabel = (tax: Tax) => {
    return (
      <div className={classes.taxLabel}>
        <Typography>{tax.label}</Typography>
      </div>
    );
  };

  return (
    <div className={classes.item}>
      <div className={classes.rowItem}>
        <img
          className={classes.imageItem}
          alt={item.name}
          src={getImageUrl(
            item.mainImage
              ? item.mainImage.id
              : item.mainImageId
              ? item.mainImageId
              : item.portraitImageId
          )}
          width="56"
          height="56"
        />
        <div className={classes.wrapItemName}>
          <div className={classes.nameItem}>{item.name}</div>
          {productTaxes ? (
            <div className={classes.wrapTaxes}>
              {productTaxes.map((el: Tax) => buildTaxLabel(el))}
            </div>
          ) : null}
        </div>
      </div>
      <div>
        <IconButton onClick={() => handleDeleteItem(item.id)}>
          <DeleteOutlinedIcon className={classes.deleteButton} />
        </IconButton>
      </div>
    </div>
  );
}

RowItem.propTypes = {
  item: PropTypes.object,
  handleDeleteItem: PropTypes.func.isRequired,
};
